"use client";

import CarCard from "@/components/cars/CarCard";
import type { Car } from "@/lib/types/database";
import { useTranslations } from "next-intl";

/** Мобильная карусель + сетка sm+ для подборок на главной. */
export default function ExploreCarStrip({ cars }: { cars: Car[] }) {
  const t = useTranslations("Explore");
  if (cars.length === 0) {
    return (
      <p className="py-8 text-center text-sm text-gray-400 dark:text-gray-500">{t("empty")}</p>
    );
  }
  return (
    <>
      <div className="flex gap-4 overflow-x-auto pb-2 sm:hidden snap-x snap-mandatory scrollbar-none">
        {cars.map((car, i) => (
          <div key={car.id} className="min-w-[72vw] snap-start flex-shrink-0">
            <CarCard car={car} />
          </div>
        ))}
      </div>
      <div className="hidden sm:grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {cars.map((car, i) => (
          <CarCard key={car.id} car={car} />
        ))}
      </div>
    </>
  );
}
